import React, { useState, useEffect } from "react";

import { Form, Button, Table } from "react-bootstrap";
import api from "../axiosConfig";

const CitaForm = () => {
  const [clientes, setClientes] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [citas, setCitas] = useState([]);
  const [estadosCierre, setEstadosCierre] = useState([]);

  const [pagina, setPagina] = useState(1);
  const [totalCitas, setTotalCitas] = useState(0);
  const porPagina = 20;

  // Filtros separados
  
  const [filtroCitas, setFiltroCitas] = useState("");
  const [busquedaCliente, setBusquedaCliente] = useState("");
  const [clienteSeleccionado, setClienteSeleccionado] = useState(""); // para guardar id

  const [editingId, setEditingId] = useState(null);

  // Formulario
  const [form, setForm] = useState({
    cliente_id: "",
    fecha: "",
    hora: "",
    motivo: "",
    observacion_cita: "",
    estado_cierre_id: ""
  });

  // Input para motivo nuevo
  const [motivoNuevo, setMotivoNuevo] = useState("");

  //alertas
  const [mensaje, setMensaje] = useState(null);
  const mostrarMensaje = (tipo, texto) => {
  setMensaje({ tipo, texto });
  setTimeout(() => setMensaje(null), 4000); // se oculta en 4s
};

  useEffect(() => {
    fetchClientes();
    fetchMotivos();
    fetchEstadosCierre();
  }, []);

  useEffect(() => {
    fetchCitas();
  }, [pagina, filtroCitas]);

  const fetchClientes = async () => {
    const res = await api.get("/clientes/");
    setClientes(res.data.resultados || res.data);
  };

  const fetchMotivos = async () => {
    const res = await api.get("/motivos/");
    console.log("Motivos recibidos:", res.data);
    setMotivos(res.data);
  };

  const fetchEstadosCierre = async () => {
    const res = await api.get("/catalogos/estados-cita");
    setEstadosCierre(res.data);
  };

  const fetchCitas = async () => {
    const skip = (pagina - 1) * porPagina;
    const res = await api.get("/citas/", {
      params: {
        buscar: filtroCitas,
        skip,
        limit: porPagina
      }
    });
    setCitas(res.data.resultados || []);
    setTotalCitas(res.data.total || 0);
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  //filtro cliente manual
  const clientesFiltrados = clientes.filter((c) => {
  const texto = busquedaCliente.toLowerCase();
  return (
    (c.nombres || "").toLowerCase().includes(texto) ||
    (c.apellidos || "").toLowerCase().includes(texto) ||
    (c.doc_identificacion || "").toLowerCase().includes(texto) ||
    (`${c.nombres || ""} ${c.apellidos || ""}`.toLowerCase().includes(texto))
  );
});

  

  // Filtro para tabla
  const handleFiltroCitas = e => {
    setFiltroCitas(e.target.value);
    setPagina(1);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      // Normalizar motivo
      const motivoIngresado = form.motivo.trim().toUpperCase();

      // Buscar si ya existe
      let motivoExistente = motivos.find(
        m => m.motivo.trim().toUpperCase() === motivoIngresado
      );

      // Si no existe, crearlo
      if (!motivoExistente && motivoIngresado !== "") {
        const res = await api.post("/motivos/", { motivo: motivoIngresado });
        motivoExistente = res.data;
        fetchMotivos();
      }

      const citaData = {
        cliente_id: parseInt(form.cliente_id),
        fecha: form.fecha,
        hora: form.hora,
        motivo: motivoIngresado,
        observacion_cita: form.observacion_cita,
        estado_cierre_id: form.estado_cierre_id || null
      };

      if (editingId) {
        await api.put(`/citas/${editingId}`, citaData);
        mostrarMensaje("success", "Cita actualizada correctamente");
      } else {
        await api.post("/citas/", citaData);
        mostrarMensaje("success", "Cita registrada correctamente");
      }

      setForm({ cliente_id: "", fecha: "", hora: "", motivo: "", observacion_cita: "", estado_cierre_id: "" });
      setMotivoNuevo("");
      //setFiltroClienteForm("");
      setEditingId(null);
      fetchCitas();
    } catch (err) {
      console.error("Error al guardar la cita:", err.response?.data || err);
    }
  };

  const handleEdit = cita => {
    setEditingId(cita.id);
    setForm({
      cliente_id: cita.cliente_id,
      fecha: cita.fecha,
      hora: cita.hora,
      motivo: getMotivoTexto(cita.motivo_id),
      observacion_cita: cita.observacion_cita || "",
      estado_cierre_id: cita.estado_cierre_id || ""
    });

    
  };

  const handleDelete = async id => {
    if (window.confirm("¿Está seguro de eliminar esta cita?")) {
      await api.delete(`/citas/${id}`);
      mostrarMensaje("danger", "Cita eliminada correctamente");
      fetchCitas();
    }
  };

  const getClienteNombre = id => {
    const cliente = clientes.find(c => c.id === id);
    return cliente ? `${cliente.nombres} ${cliente.apellidos || ""}` : "Desconocido";
  };

  const getMotivoTexto = motivoId => {
    const motivo = motivos.find(m => m.id === motivoId);
    return motivo ? motivo.motivo : "No especificado";
  };

  const totalPaginas = Math.ceil(totalCitas / porPagina);

  return (
    <div className="card p-4">
      <h3 className="text-primary">{editingId ? "Editar Cita" : "Registrar Cita"}</h3>
       {mensaje && (
  <div className={`alert alert-${mensaje.tipo} mt-3`} role="alert">
    {mensaje.texto}
  </div>
)}
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-12 col-md-4">
            <Form.Group>
  <Form.Label>Buscar Cliente</Form.Label>
  <Form.Control
    type="text"
    placeholder="Escriba un nombre..."
    value={busquedaCliente}
    onChange={(e) => setBusquedaCliente(e.target.value)}
  />
</Form.Group>
          </div>

          <div className="col-12 col-md-4">
            <Form.Group controlId="cliente_id" className="mb-3">
              <Form.Label>O seleccionar cliente</Form.Label>
              <Form.Select
                name="cliente_id"
                value={form.cliente_id}
                onChange={(e) => {
                  handleChange(e);
                  setClienteSeleccionado(e.target.value);
                }}
              >
              
                <option value="">Seleccione un cliente</option>
                {clientesFiltrados.map(c => (
                  <option key={c.id} value={c.id}>
                    {c.doc_identificacion} - {c.nombres} {c.apellidos}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-12 col-md-4">
            <Form.Group controlId="fecha" className="mb-3">
              <Form.Label>Fecha</Form.Label>
              <Form.Control
                type="date"
                name="fecha"
                value={form.fecha}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-4">
            <Form.Group controlId="hora" className="mb-3">
              <Form.Label>Hora</Form.Label>
              <Form.Control
                type="time"
                name="hora"
                value={form.hora}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </div>

          <div className="col-12 col-md-4">
            <Form.Group controlId="motivo" className="mb-3">
  <Form.Label>Motivo</Form.Label>
  <Form.Select
    value={form.motivo || "seleccionar"}
    onChange={e => {
      if (e.target.value === "nuevo") {
        setForm({ ...form, motivo: "" });
      } else {
        setForm({ ...form, motivo: e.target.value });
      }
    }}
  >
    <option value="seleccionar" disabled>Seleccione un motivo</option>
    {motivos.map(m => (
      <option key={m.id} value={m.motivo}>{m.motivo}</option>
    ))}
    {/*<option value="nuevo">Agregar nuevo motivo...</option>*/}
  </Form.Select>

  {/* Input solo aparece si se selecciona "nuevo" */}
  {form.motivo === "" && (
    <Form.Control
      type="text"
      placeholder="Escriba un nuevo motivo"
      value={motivoNuevo}
      onChange={e => {
        setMotivoNuevo(e.target.value);
        setForm({ ...form, motivo: e.target.value });
      }}
      className="mt-2"
    />
  )}
</Form.Group>
          </div>
          {/* SOLO SE MUESTRA AL EDITAR */}
{editingId && (
          <div className="col-12 col-md-4">
            <Form.Group controlId="estado_cierre_id" className="mb-3">
              <Form.Label>Estado de Cierre</Form.Label>
              <Form.Select
                name="estado_cierre_id"
                value={form.estado_cierre_id}
                onChange={handleChange}
              >
                <option value="">Seleccione un estado</option>
                {estadosCierre.map(e => (
                  <option key={e.id} value={e.id}>{e.nombre}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          )}
        </div>

         
        <div className="row">
          {/* SOLO SE MUESTRA AL EDITAR */}
         {editingId && (  
          <div className="col-12 col-md-4">
            <Form.Group controlId="observacion_cita" className="mb-3">
              <Form.Label>Observaciones</Form.Label>
              <Form.Control
                as="textarea"
                name="observacion_cita"
                value={form.observacion_cita}
                onChange={handleChange}
                placeholder="Escriba alguna observación..."
                rows={3}
              />
            </Form.Group>
          </div>
          )}
        </div>

        <Button variant="primary" type="submit">
          {editingId ? "Actualizar Cita" : "Guardar Cita"}
        </Button>
        
          <Button variant="secondary" className="ms-2" onClick={() => {
            setEditingId(null);
            setForm({ cliente_id: "", fecha: "", hora: "", motivo: "", observacion_cita: "", estado_cierre_id: "" });
            setMotivoNuevo("");
            //setFiltroClienteForm("");
          }}>
            Cancelar
          </Button>
        
      </Form>

      <h5 className="mt-4">Citas Registradas</h5>
      <Form.Group className="col-12 col-md-3 mb-3">
        <Form.Control
          type="text"
          placeholder="Buscar por nombre o apellido"
          value={filtroCitas}
          onChange={handleFiltroCitas}
        />
      </Form.Group>

      <div className="table-responsive">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Motivo</th>
              <th>Observaciones</th>
              <th>Estado de Cierre</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {citas.map(cita => (
              <tr key={cita.id}>
                <td>{cita.id}</td>
                <td>{cita.cliente ? `${cita.cliente.nombres || ""} 
                ${cita.cliente.apellidos || ""}` : getClienteNombre(cita.cliente_id)}</td>
                <td>{cita.fecha}</td>
                <td>{cita.hora}</td>
                <td>{getMotivoTexto(cita.motivo_id)}</td>
                <td>{cita.observacion_cita || ""}</td>
                <td>{cita.estado_cierre_id ? estadosCierre.find(e => e.id === cita.estado_cierre_id)?.nombre : "-"}</td>
                <td>
                  <button onClick={() => handleEdit(cita)} className="btn btn-sm "
                   style={{ backgroundColor: "#4e73df", borderColor: "#1cc88a", color: "#fff" }}>
                    ✏ Editar
                  </button>
                  {/*<button onClick={() => handleDelete(cita.id)} className="btn btn-sm btn-danger ms-1">
                    🗑 Eliminar
                  </button>*/}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Paginación */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <Button variant="secondary" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>← Anterior</Button>
        <span>Página {pagina} de {totalPaginas}</span>
        <Button variant="secondary" disabled={pagina === totalPaginas} onClick={() => setPagina(p => p + 1)}>Siguiente →</Button>
      </div>
    </div>
  );
};

export default CitaForm;
